module.exports = __webpack_public_path__ + "img/img_hope02.ae376008.png";